var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPlainRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17 1a1 1 0 000 1.41L4.71 6 1.17 9.54a1 1 0 101.42 1.41l4.24-4.24a1 1 0 000-1.42L2.59 1a1 1 0 00-1.42 0z",
    fill: "#8A9AA7"
  })));
}
export default SvgArrowPlainRight;